import { Controller } from "react-hook-form";
import { FormControlLabel, Radio, Typography } from "@mui/material";
import {
  IconChecked,
  IconUnChecked,
} from "@components/FormControllers/helper/IconRoundedHepler";

import { buildClass } from "@utils/tag";
import useTranslation from "next-translate/useTranslation";

const RadioValidateController = ({
  control,
  name,
  inputValue,
  label,
  ...props
}) => {
  const { lang } = useTranslation();
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={inputValue}
      render={({ field: { value, ...otherRenderProps } }) => {
        return (
          <FormControlLabel
            name={name}
            value={value ?? false}
            sx={{
              margin: 0,
              alignItems: "flex-start",
              "& .MuiRadio-root": {
                paddingTop: "0",
              },
              "& .MuiTypography-root": {
                paddingTop: "2px",
                color: "#333333",
                fontSize: "14px",
                lineHeight: "16px",
                fontFamily: "Expo_med",
                fontWeight: "400",
                ...(lang === "en"
                  ? { marginLeft: "10px !important" }
                  : { marginRight: "10px !important" }),
              },
            }}
            label={
              <Typography
                className={buildClass(
                  { "text-[#2B64F5]": inputValue },
                  { "text-[#333333]": !inputValue },
                  "!text-[12px] sm:!text-[16px] "
                )}
              >
                {label}
              </Typography>
            }
            control={
              <Radio
                checked={inputValue ?? false}
                disabled={!inputValue ?? true}
                checkedIcon={<IconChecked sx={{ marginTop: "8px" }} />}
                icon={<IconUnChecked sx={{ marginTop: "8px" }} />}
                sx={{
                  width: "25px",
                  height: "25px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "20px",
                }}
              />
            }
            {...otherRenderProps}
            {...props}
          />
        );
      }}
    />
  );
};

export default RadioValidateController;
